import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastComponent } from "../../layout/toast/toast.component";
import Swal from 'sweetalert2';

@Component({
    selector: 'app-appconfig',
    templateUrl: './appconfig.component.html',
    styleUrls: ['./appconfig.component.css']
})

export class AppconfigComponent implements OnInit {
    @ViewChild(ToastComponent, { static: true }) toastComponent: ToastComponent;
    constructor(public httpClient: HttpClient){}

    loading:boolean = true;
    data:any = [];      //編輯中的資料
    ori_data:any = [];  //原始值 拿來比對哪幾筆真的有改
    missing:any = [];   //config 缺少的設定

    ngOnInit(): void {
        this.init_list();
    }

    init_list(){
        this.loading = true;
        this.httpClient.post<any>("/setting/app_config.php",{action:'read'}).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.data = res.data;
                this.ori_data = JSON.parse(JSON.stringify(res.data));//複製一份
                this.missing = res.missing?res.missing:[];
            }else{
                this.data = [];
                this.missing = [];
                this.toastComponent.showMessage(res.msg?res.msg:'讀取失敗', 'error');
            }
        }, error => {
            this.loading = false;
            console.log(error);
        });
    }

    missing_text(){
        return this.missing.map(item => item.name+'('+item.title+')').join('、');
    }

    is_changed(item,i){
        if(!this.ori_data[i]){
            return false;
        }
        return (''+this.ori_data[i].value) !== (''+item.value);
    }

    changed_list(){
        return this.data.filter((item,i) => item.field && this.is_changed(item,i));
    }

    save(){
        const change = this.changed_list();
        if(change.length==0){
            this.toastComponent.showMessage('沒有變更', 'error');
            return;
        }

        Swal.fire({
            title: '確定要修改這 '+change.length+' 筆設定?',
            text: change.map(item => item.name+' → '+(item.value===''?'(空白)':item.value)).join('、'),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "確定",
            cancelButtonText: "取消",
        }).then((result) => {
            if(result.isConfirmed){
                this.loading = true;
                const body = {
                    action: 'save',
                    data: change.map(item => ({id:item.id, value:item.value}))
                };
                this.httpClient.post<any>("/setting/app_config.php",body).subscribe(res => {
                    this.loading = false;
                    if(res.status){
                        Swal.fire("修改完成!", "", "success");
                    }else{
                        Swal.fire("喔喔 出問題了!", res.msg?res.msg:'', "error");
                    }
                    this.init_list();
                }, error => {
                    this.loading = false;
                    console.log(error);
                });
            }
        });
    }

    reset(){
        this.data = JSON.parse(JSON.stringify(this.ori_data));
    }

    init_config(){
        Swal.fire({
            title: '要在 config 補建缺少的設定嗎?',
            text: this.missing.map(item => item.name+'('+item.title+')').join('、'),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "確定",
            cancelButtonText: "取消",
        }).then((result) => {
            if(result.isConfirmed){
                this.loading = true;
                const body = {action:'init'};
                this.httpClient.post<any>("/setting/app_config.php",body).subscribe(res => {
                    this.loading = false;
                    if(res.status){
                        Swal.fire("建立完成!", res.msg?res.msg:'', "success");
                    }else{
                        Swal.fire("喔喔 出問題了!", res.msg?res.msg:'', "error");
                    }
                    this.init_list();
                }, error => {
                    this.loading = false;
                    console.log(error);
                });
            }
        });
    }
}
